import useLoadPublicDocument from './useLoadPublicDocument';

/**
 * Charge un ticket public B2C (consultation sans authentification).
 * Wrapper fin autour de useLoadPublicDocument : dérive les mêmes champs qu'auparavant
 * (ticketDetail, section, companyInfos, moduleInfos, pointsFidelite) depuis la réponse ticket_public.
 */
const useLoadPublicTicket = (company, id, token) =>{
    const [loading,response,error404] = useLoadPublicDocument('ticket_public', company, id, token)

    const ticketDetail = response.data || {}
    const section = response.section || {}
    const companyInfos = response.company || {}
    const moduleInfos = response.module || {}
    const pointsFidelite = {
        total:response.total_point_fidelite_client,
        acquis:response.total_point_fidelite_ticket,
        cashbackTotal:response.fidelite_client && response.fidelite_client.valeur_cfp ? response.fidelite_client.valeur_cfp : 0,
        cashbackAcquis:response.valeur_cfp_ticket ? response.valeur_cfp_ticket : 0,
        mode:response.fidelite_client ? response.fidelite_client.mode_fidelite : null
    }

    return [loading,ticketDetail,section,companyInfos,moduleInfos,pointsFidelite,error404]
}

export default useLoadPublicTicket;
